module.exports = __webpack_public_path__ + "static/media/CatLogoV9.fd3da79c.svg";